import { propertyValuesSemigroup } from './propertyValues';
/**
 * Concatinates Properties together by concatinating the propertyValues records
 *
 * if displayNames are different, we keep the first.
 *
 * { displayName: "X", propertyValues: one } combined with { displayName: "Y", propertyValues: two }
 * results in { displayName: "Y", propertyValues: propertyValuesSemigroup.concat(one, two) }
 */
export const propertySemigroup = {
    concat(x, y) {
        const propertyValues = propertyValuesSemigroup.concat(x.propertyValues, y.propertyValues);
        return { displayName: y.displayName, propertyValues };
    },
};
